<!--
    定位交底
-->
<template>
    <div class="content">
        <div class="details-top flex">
            <div class="top-info">
                <div class="flex">
                    <div class="top-title">{{arrMent.process_name}}</div>
                    <div class="top-order">{{arrMent.wokor_name}}</div>
                </div>
                <div class="top-time">施工时间：{{arrMent.new_actualstartedon}}  {{arrMent.new_actualfinishedon}}</div>
            </div>
            <div class="completed-icon">
                <!-- <img src="../../../assets/images/archives/completed.png" /> -->
                <img v-if="arrMent.new_status==1" src="@/assets/images/archives/dispatched.png" alt="">
                <img v-if="arrMent.new_status==2" src="@/assets/images/archives/dispatch.png" alt="">
                <img v-if="arrMent.new_status==3" src="@/assets/images/archives/responded.png" alt="">
                <img v-if="arrMent.new_status==4" src="@/assets/images/archives/completed.png" alt="">
                <img v-if="arrMent.new_status==5" src="@/assets/images/archives/reviewed.png" alt="">
                <img v-if="arrMent.new_status==91" src="@/assets/images/archives/qualified.png" alt="">
                <img v-if="arrMent.new_status==92" src="@/assets/images/archives/unqualified.png" alt="">
                <img v-if="arrMent.new_status==93" src="@/assets/images/archives/modifying.png" alt="">
                <img v-if="arrMent.new_status==94" src="@/assets/images/archives/modified.png" alt="">
            </div>
        </div>
        <!-- 选择框 -->
        <div class="taber-box">
            <div :class="nTaber==index?'taber-title-item':'taber-title'" v-for="(item,index) in arrTaber" :key="index"
                @click="changeTaber(index)">
                {{item.title}}
            </div>
        </div>
        <!-- 基本信息 -->
        <div v-show="nTaber == 0">
            <div v-for="(item,index) in arrOrder" :key="index">
                <div class="list-box">
                    <div class="list-top-box">
                        <div class="list-title">{{item.title}}</div>
                    </div>
                    <div class="list-content flex" v-for="(item,index) in item.content" :key="index"
                        :style="{background: (index % 2 == 1 ? '#fff':'#F9F9FB')}">
                        <div class="item-title">{{item.label}}</div>
                        <div class="item-content">{{item.value}}</div>
                    </div>
                    <div class="list-bottom"></div>
                </div>
            </div>
        </div>
        <!-- 过程反馈 -->
        <div v-show="nTaber == 1">
            <div v-for="(item,index) in arrOrder" >
                <div class="list-box" v-if="item.type == 'table'">
                    <div class="list-top-box">
                        <div class="list-title">{{item.title}}</div>
                    </div>
                    <div class="list-content flex" v-for="(item,index) in item.content" :key="index"
                        :style="{background: (index % 2 == 1 ? '#fff':'#F9F9FB')}">
                        <div class="item-title">{{item.label}}</div>
                        <div class="item-content">{{item.value}}</div>
                    </div>
                    <div class="list-bottom"></div>
                </div>
            </div>
            <div>
                <div class="list-box" v-for="(item,index) in arrOrder" v-if="item.type != 'table'">
                    <div class="list-top-box">
                        <div class="list-title">{{item.title}}</div>
                    </div>
                    <div>
                        <div class="type-img">
                            <!-- <div class="type-img-title">{{item.title}}</div> -->
                            <div class="type-item-img">
                                <div v-for="(it,inx) in item.content" :key="inx">
                                    <div class="type-img-title">{{it.title}}</div>
                                    <div class="item-img" v-for="(im,ixx) in it.content" :key="ixx">
                                        <img :src="im" @click="clickImg(it.content,ixx)"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-bottom"></div>
                </div>
            </div>
        </div>
        <!-- 考勤记录 -->
        <div v-show="nTaber == 2">
            <div class="list-box">
                <div class="list-top-box">
                    <div class="list-title">{{arrOrder.title}}</div>
                </div>
                <div class="record-box" v-for="(item,index) in arrContent">
                    <div class="timeline">
                        <div class="time-icon"><img src="../../../assets/images/archives/workOrder/time-icon.png" />
                        </div>
                        <div class="data-detail">{{item.date}}</div>
                    </div>
                    <div class="boder-box"></div>
                    <div v-for="(it,inx) in item.content">
                        <div class="data-box">
                            <div class="time-title">{{it.time}}</div>
                            <div class="signIn">{{it.content.title}}</div>
                        </div>
                        <div class="signIn-content" v-if="it.content.address !== ''">
                            <div class="signIn-title">{{it.content.address}}</div>
                            <div class="contentImg" v-if="false">
                                <div v-for="(ie,imt) in item.image">
                                    <div class="signIn-img"><img :src="item.image" /></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-bottom"></div>
            </div>
        </div>
        <img class="back_icon" @click="touchBack" src="~@/assets/images/archives/dossier/back_icon.png" />
        <van-image-preview v-model="imgShow" :startPosition="lookImgIndex" :closeable="true" @close="close" :images="arrImg"></van-image-preview>
    </div>
</template>

<script>
    import oData from '@/js/archives/survey/index.js'
    import { getWorkorderInfo } from "@/js/archives/construction.js";
    export default {
        data() {
            return {
                arrTaber: [{
                    title: '基本信息',
                }, {
                    title: '过程反馈',
                }, {
                    title: '考勤记录',
                }],
                nTaber: 0,
                lookImgIndex:0,
                //过程反馈 >
                //过程反馈 > 空调设备定位
                arrWind: [{
                        title: '现场定位末端风盘位置',
                        arrList: [{
                                image: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg'
                            }
                        ]
                    },
                    {
                        title: '现场定位主管道过墙孔位置',
                        arrList: [{
                                image: 'https://s1.ax1x.com/2022/08/04/vewSvq.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewSvq.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewSvq.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewSvq.jpg'
                            }
                        ]
                    },
                    {
                        title: '现场定位中控器电源位置',
                        arrList: [{
                                image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                            },
                            {
                                image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                            }
                        ]
                    }
                ],
                //考勤记录 > 图片
                arrSignImg: [{
                        data: '2022-06-23 星期四',
                        timeConten: [{
                                time: '08:22',
                                title: '签到',
                                content: '江苏省南京市栖霞区文苑路9号'
                            },
                            {
                                time: '18:22',
                                title: '签退',
                                content: '江苏省南京市栖霞区文苑路9号',
                                image: [{
                                        image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                                    },
                                    {
                                        image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                                    },
                                    {
                                        image: 'https://s1.ax1x.com/2022/08/04/vewCrV.jpg'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        data: '2022-06-25 星期六',
                        timeConten: [{
                                time: '08:01',
                                title: '签到',
                                content: '江苏省南京市栖霞区文苑路9号'
                            },
                            {
                                time: '18:38',
                                title: '签退',
                                content: '江苏省南京市栖霞区文苑路9号',
                                image: []
                            }
                        ]
                    }
                ],
                orderTab: '',
                strTaber: 'basic',
                arrOrder: [],
                arrImg:[],
                imgShow: false,
                arrContent:[],
                arrMent:[],
            }
        },
        created() {
            this.orderTab = this.$route.query.workorderId
            this.getDetalis()
            this.getTetails()
        },
        methods: {
            changeTaber(index) {
                this.nTaber = index
                if (index == 0) {
                    this.strTaber = 'basic'
                } else if (index == 1) {
                    this.strTaber = 'progress'
                } else {
                    this.strTaber = 'attendance'
                }
                this.getDetalis()
            },
            getDetalis() {
                this.$store.commit("loadSwitch", true);
                oData.orderDetail({
                    workorder_id: this.orderTab,
                    tab: this.strTaber,
                }).then(res => {
                    this.$store.commit("loadSwitch", false);
                    this.arrOrder = res.data.data.result
                    this.arrContent = res.data.data.result.content
                    this.$previewRefresh()
                    console.log(this.arrOrder,'this.arrOrder')
                })
            },
            clickImg(item,index){
                console.log(item)
                // this.lookImgIndex = index
                this.arrImg = item
                this.imgShow = true
            },
            close(){
                this.arrImg = []
            },
            getTetails(){
                getWorkorderInfo({
                    workorder_id: this.orderTab,
                }).then(res =>{
                    this.arrMent = res.data.data.result
                    console.log(this.arrMent,'this.arrMent')
                })
            },
            touchBack(){
                this.$router.back()
            }
        },
    }
</script>

<style scoped lang="scss">
    .flex {
        display: flex;
        justify-content: space-between;
    }

    .type-item-img::-webkit-scrollbar {
        display: none
    }

    .content {
        width: 100%;
        height: 100%;
        background: rgba(243, 246, 255, 1);
        padding: 32px;
        min-height: 100vh;

        .details-top {
            .top-info {
                .flex {
                    display: flex;

                    .top-title {
                        font-size: 36px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                    }

                    .top-order {
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(85, 85, 85, 0.6);
                        margin-left: 16px;
                        margin-top: 14px;
                    }
                }

                .top-time {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #555555;
                    margin-top: 18px;
                }
            }

            .completed-icon {
                img {
                    width: 160.74px;
                    height: 152px;
                }
            }
        }

        .taber-box {
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            border-radius: 16px;
            margin-top: 28px;
            display: flex;
            justify-content: space-evenly;

            .taber-title {
                text-align: center;
                line-height: 80px;
                font-size: 24px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #A3A3A3;
            }

            .taber-title-item {
                text-align: center;
                line-height: 80px;
                font-size: 24px;
                font-family: PingFang SC-Semibold, PingFang SC;
                font-weight: 600;
                color: #0D53FC;
                border-bottom: #0D53FC 5px solid;
            }
        }

        .list-box {
            .list-top-box {
                width: 100%;
                padding: 36px 44px;
                background: #fff;
                margin-top: 16px;
                border-radius: 16px 16px 0 0;

                .list-title {
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    font-weight: 600;
                    color: #333333;
                    padding-left: 16px;
                    border-left: #0D53FC 5px solid;
                }
            }

            .list-content {
                padding: 22px 48px 24px 48px;

                .item-title {
                    font-size: 24px;
                    font-family: PingFang SC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                }

                .item-content {
                    font-size: 24px;
                    font-family: PingFang SC-Medium, PingFang SC;
                    color: #333333;
                    text-align: right;
                }
            }

            .list-bottom {
                width: 100%;
                height: 64px;
                background: #fff;
                border-radius: 0 0 16px 16px;
            }

            .type-img {
                padding: 0px 0px 1px 48px;
                background: #fff;




                .type-item-img {
                    // margin-top: 32px;
                    margin-bottom: 34px;
                    overflow-x: scroll;
                    width: 100%;
                    white-space: nowrap;

                    .type-img-title {
                        margin-top: 64px;
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                    }

                    .item-img {
                        padding: 32px 0 0px 0;
                        width: 160px;
                        display: inline-block;
                        margin-right: 16px;

                        img {
                            width: 160px;
                            height: 160px;
                            border-radius: 16px;
                        }
                    }
                    .reply-box{
                        padding: 32px 0 32px 0;
                    }
                }
            }

            .record-box {
                // display: flex;
                width: 100%;
                padding: 0 0 0 46px;
                background: #FFF;

                .timeline {
                    display: flex;

                    .time-icon {
                        img {
                            width: 64px;
                            height: 64px;
                        }
                    }

                    .data-detail {
                        margin-left: 30px;
                        font-size: 28px;
                        font-family: PingFang SC-Semibold, PingFang SC;
                        font-weight: 600;
                        color: #333333;
                        line-height: 64px;
                    }
                }

                .boder-box {
                    height: 64px;
                    margin-left: 30px;
                    border-left: 4px dashed #EEEEEE;
                }

                .data-box {
                    display: flex;

                    // margin-left: 30px;
                    .time-title {
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                    }

                    .signIn {
                        font-size: 24px;
                        margin-left: 30px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000000;
                    }
                }

                .signIn-content {
                    padding: 0 0 64px 58px;
                    margin: 0px 0 0 30px;
                    border-left: 4px dashed #EEEEEE;

                    .signIn-title {
                        margin-top: 16px;
                        font-size: 24px;
                        font-family: PingFang SC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                    }

                    .contentImg {
                        margin-top: 16px;
                        display: flex;
                        flex-wrap: wrap;

                        .signIn-img {
                            margin: 16px 16px 0 0;

                            img {
                                width: 160px;
                                height: 160px;
                                border-radius: 16px;
                            }
                        }
                    }
                }


            }
        }
        .back_icon{
            position: fixed;
            left: 32px;
            bottom: calc(env(safe-area-inset-bottom) + 150px);
            z-index: 999;
            width: 100px;
            height: 100px;
        }
    }
</style>
